/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: {
      value: 1,
    },
    stt: "",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "",
    value2: {
      value: ""
    },
    title: {
      value: "Kết quả kinh doanh ghi nhận theo báo cáo tài chính",
    },
  },
  {
    id: {
      value: 2,
    },
    stt: "1",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "[04]",
    value2: {
      value: 0
    },
    title: {
      value: "Doanh thu bán hàng và cung cấp dịch vụ",
    },
  },
  {
    id: {
      value: 3,
    },
    stt: "",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[05]",
    value2: {
      value: 0
    },
    title: {
      value: "Trong đó: - Doanh thu bán hàng hoá, dịch vụ xuất khẩu",
    },
  },
  {
    id: {
      value: 4,
    },
    stt: "2",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "[06]",
    value2: {
      value: 0
    },
    title: {
      value: "Các khoảng giảm trừ doanh thu ([06]=[07]+[08]+[09])",
    },
  },
  {
    id: {
      value: 5,
    },
    stt: "a",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[07]",
    value2: {
      value: 0
    },
    title: {
      value: "Chiếc khấu thương mại",
    },
  },
  {
    id: {
      value: 6,
    },
    stt: "b",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[08]",
    value2: {
      value: 0
    },
    title: {
      value: "Giảm giá hàng bán",
    },
  },
  {
    id: {
      value: 7,
    },
    stt: "c",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[09]",
    value2: {
      value: 0
    },
    title: {
      value: "Giá trị hàng bán bị trả lại",
    },
  },
  {
    id: {
      value: 8,
    },
    stt: "3",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "[10]",
    value2: {
      value: 0
    },
    title: {
      value: "Doanh thu hoạt động tài chính",
    },
  },
  {
    id: {
      value: 9,
    },
    stt: "",
    bg: false,
    bold: false,
    ilalic: true,
    value1: "[11]",
    value2: {
      value: 0
    },
    title: {
      value: "Trong đó: Doanh thu từ lãi tiền gửi",
    },
  },
  {
    id: {
      value: 10,
    },
    stt: "4",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "[12]",
    value2: {
      value: 0
    },
    title: {
      value: "Chi phí sản xuất, kinh doanh hàng hoá, dịch vụ ([12]=[13]+[14]+[15])",
    },
  },
  {
    id: {
      value: 11,
    },
    stt: "a",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[13]",
    value2: {
      value: 0
    },
    title: {
      value: "Giá vốn bán hàng",
    },
  },
  {
    id: {
      value: 12,
    },
    stt: "b",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[14]",
    value2: {
      value: 0
    },
    title: {
      value: "Chi phí bán",
    },
  },
  {
    id: {
      value: 13,
    },
    stt: "c",
    bg: false,
    bold: false,
    ilalic: false,
    value1: "[15]",
    value2: {
      value: 0
    },
    title: {
      value: "Chi phí quản lý doanh nghiệp",
    },
  },
  {
    id: {
      value: 14,
    },
    stt: "5",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "[16]",
    value2: {
      value: 0
    },
    title: {
      value: "Chi phí tài chính",
    },
  },
  {
    id: {
      value: 15,
    },
    stt: "",
    bg: false,
    bold: false,
    ilalic: true,
    value1: "[17]",
    value2: {
      value: 0
    },
    title: {
      value: "Trong đó: Chi phí lãi tiền vay",
    },
  },
  {
    id: {
      value: 16,
    },
    stt: "6",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "[18]",
    value2: {
      value: 0
    },
    title: {
      value: "Lợi nhuận thuần từ hoạt động kinh doanh ([18]=[04]-[06]+[10]-[12]-[16])",
    },
  },
  {
    id: {
      value: 17,
    },
    stt: "7",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "[19]",
    value2: {
      value: 0
    },
    title: {
      value: "Thu nhập khác",
    },
  },
  {
    id: {
      value: 18,
    },
    stt: "8",
    bg: false,
    bold: true,
    ilalic: false,
    value1: "[20]",
    value2: {
      value: 0
    },
    title: {
      value: "Chi phí khác",
    },
  },
  {
    id: {
      value: 19,
    },
    stt: "9",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "[21]",
    value2: {
      value: 0
    },
    title: {
      value: "Lợi nhuận khác ([21]=[19]-[20])",
    },
  },
  {
    id: {
      value: 20,
    },
    stt: "10",
    bg: true,
    bold: true,
    ilalic: false,
    value1: "[22]",
    value2: {
      value: 0
    },
    title: {
      value: "Tổng lợi nhuận kế toán trước thuế thu nhập doanh nghiệp ([22]=[18]+[21])"
  }
  }
];

export default function Table2({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
        <thead style={{ background: "#eaeae9" }}>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Chỉ tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã chỉ tiêu</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số tiền</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center"}}>
                (1)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (2)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (3)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (4)
              </Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value + index}>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.bg ? "transparent" : "#ddeff3",
                      fontWeight: !row.bold ? "normal" : "bold",
                      fontStyle: !row.ilalic ? "normal" : "italic"
                    }}
                  >
                    {row.stt}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.bg ? "transparent" : "#ddeff3",
                      fontWeight: !row.bold ? "normal" : "bold",
                      fontStyle: !row.ilalic ? "normal" : "italic"
                    }}
                  >
                    {row.title.value}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.bg ? "transparent" : "#ddeff3",
                      fontWeight: !row.bold ? "normal" : "bold",
                      fontStyle: !row.ilalic ? "normal" : "italic"
                    }}
                  >
                    {row.value1}
                  </Td>

                  <Td
                        row={row}
                        style={{
                          textAlign: "right",
                          background: !row.bg ? "transparent" : "#ddeff3",
                          fontWeight: !row.bold ? "normal" : "bold",
                          fontStyle: !row.ilalic ? "normal" : "italic"
                        }}
                      >
                        {row.bg ? (
                          row.value2.value
                        ) : (
                          <InputTable
                            id={row.id.value}
                            name="value2"
                            value={row.value2.value}
                            onChange={handleChange}
                            isBold = {row.bold}
                          />
                        )}
                      </Td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, isBold, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: isBold ? "bold" : "normal"
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
